enum BlogActions {
    FETCH_LIST = "blogFetchList",
    GET_ITEM = "blogGetItem",
    CREATE_ITEM = "blogCreateItem",
    UPDATE_ITEM = "blogUpdateItem",
    DELETE_ITEM = "blogDeleteItem",
    REFRESH_LIST = "blogRefreshList",
    FETCH_SETTINGS = "blogFetchSettings",
    CREATE_SETTING = "blogCreateSetting",
    UPDATE_SETTING = "blogUpdateSetting",
    DELETE_SETTING = "blogDeleteSetting",
    FETCH_TOPICS = "blogFetchTopics",
    CREATE_TOPIC = "blogCreateTopic",
    UPDATE_TOPIC = "blogUpdateTopic",
    DELETE_TOPIC = "blogDeleteTopic",
}

enum BlogMutation {
    SET_RENDER_UPDATE = "blogListRenderNeeded",
    SET_LIST_RESULT = "blogListResult",
    SET_SETTINGS_RESULT = "blogSettingsResult",
    SET_TOPICS_RESULT = "blogTopicsResult",
}

export {BlogActions, BlogMutation};
